<template>
	<!-- 支付弹框 -->
	<div class="modal-wrap" v-if="notToast">
        <div class="modal-content">
            <!-- 取消成功，催单成功 -->
            <div class="show-wrap">
                <div class="show-logo"></div>
                <p class="show-text">{{ToastText}}</p>
            </div>
        </div>
	</div>
</template>

<script>
    export default {
        data(){
            return{
                notToast:this.isToast
            }
        },
		props:{
            isToast: {
                type: Boolean,
            },
            
            ToastText: {
                type: String,
            },
		},
        
        name: 'ToastModal',
        
        methods:{
            clearTimer() {
                if (this.timer) {
                  clearTimeout(this.timer);
                }
            }  
        },
        
        watch:{
            isToast(){
                this.notToast = this.isToast;
                this.clearTimer();
                if(this.notToast){
                    this.timer = setTimeout(()=>{
                       this.notToast = false
                    },1500)
                }
            },
        }
    };
</script>
<style lang="less" scoped>
    @import '~@/assets/styles/variable.less';
    @import '~@/assets/styles/handleMethods.less';
    @import '~@/assets/styles/reset.css';
	section{font-family:PingFangSC-Regular;font-weight:400;background:#FFF}
    .modal-wrap {position: fixed;width: 100vw;height: 100vh;top: 0;left: 0;background:rgba(0,0,0,0.6);display: flex;justify-content: center;align-items: center; z-index:12;}
    /* 取消成功,催单成功 */
    .show-wrap{.w(207.5);.h(200);margin: 0 auto;background:#FFF;.p-t(43);}
    .show-logo{.w(70);.h(70);margin: 0 auto;background: url(../assets/images/order-manage/pic_recharge_right2.png) center center no-repeat;background-size: cover}
    .show-text{.w(115);margin: 0 auto;.f-s(14);.m-t(18);font-family:PingFangSC-Regular;font-weight:400;color:rgba(20,20,20,1);text-align: center}
</style>
